/**
 * Shared numeric formatters used across journey components.
 * Keeps formatting rules centralized for consistency.
 */
export const formatMoney = (value: number | null | undefined): string =>
  `€${Math.round(value ?? 0)}`;

export const formatKg = (value: number | null | undefined): string =>
  `${Math.round(value ?? 0)} kg`;

export const formatDistance = (value: number | null | undefined): string =>
  `${Math.round(value ?? 0)} km`;

